import { AuthService } from "./Auth.service";

export default {
  authService: {
    class: AuthService,
    public: true,
    arguments: [{ $ref: "apiService" }, { $ref: "accessTokenService" }]
  }
};
